import request from "@/utils/request_1";
import baseUrl from "@/utils/base-url";

export function authUser(str,timestamp1,param) {
    return request({
        url: baseUrl.tiku_base + 'user/auth',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/prs.cxt.v1+json',
            'signtype' : 'tiku',
            'sign' : str,
            'timestamp':timestamp1,
           // 'usertoken':localStorage.getItem('h5_token'),
           // 'appid':localStorage.getItem('h5_appid'),
           // 'userid':localStorage.getItem('h5_user_id')
        },
        method: "post",
        params: param
    })
}
// 记录 步骤
export function recordStep(data) {
    return request({
        url: baseUrl.tiku_base + 'daily/handler',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/prs.cxt.v1+json',
            'signtype':"tiku",
            'usertoken':localStorage.getItem('h5_usertoken'),
            'appid':localStorage.getItem('h5_appid'),
            'userid':localStorage.getItem('h5_user_id'),
            'provinceid':localStorage.getItem('h5_province_id'),
        },
        method: "post",
        data: data
    })
}
// 记录 进展
export function recordProgress(data) {
    return request({
        url: baseUrl.tiku_base + 'daily/record',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/prs.cxt.v1+json',
            'signtype':"tiku",
            'usertoken':localStorage.getItem('h5_usertoken'),
            'appid':localStorage.getItem('h5_appid'),
            'userid':localStorage.getItem('h5_user_id'),
            'provinceid':localStorage.getItem('h5_province_id'),
        },
        method: "post",
        params: data
    })
}

export function faceUrl(data) {
    return request({
        url: baseUrl.h5face +"studytime/faceurl",
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/json',
            'usertoken':localStorage.getItem('h5_usertoken'),
            'appid':localStorage.getItem('h5_appid'),
            'userid':localStorage.getItem('h5_user_id'),
            'provinceid':localStorage.getItem('h5_province_id'),
            'uuid':localStorage.getItem('h5_uuid'),
        },
        method: "get",
        params: data
    })
}
